module.exports = __webpack_public_path__ + "img/NE.49b23e5b.png";